import React from 'react';
import { Pressable } from 'react-native';
import Svg, { Path, Rect, SvgProps } from 'react-native-svg';
import { TStyle } from '../../../types/TStyle';

type Props = {
	containerStyles?: TStyle;
	onPress?: () => void;
	color?: string;
} & Omit<SvgProps, 'onPress' | 'color'>;

const PauseIcon = ({ containerStyles, onPress, color, ...props }: Props) => {
	return (
		<Pressable style={containerStyles} onPress={onPress}>
			<Svg viewBox="0 0 24 24" {...props}>
				<Path fill="none" d="M0 0h24v24H0z" />
				<Rect width="4" height="16" x="6" y="4" fill={color} />
				<Rect width="4" height="16" x="14" y="4" fill={color} />
			</Svg>
		</Pressable>
	);
};

export default PauseIcon;
